import React from "react";
import styles from "./style.module.scss";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PageNotFound = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const backToHome = () => {
    history.push("/");
  };

  const goBack = () => {
    if (window.history.length > 1) {
      history.goBack();
    } else {
      history.push("/");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <p className={styles.eyebrow}>
          {t("page_not_found.eyebrow", "Page not found")}
        </p>
        <p className={styles.code} aria-hidden="true">
          {t("page_not_found.code", "404")}
        </p>
        <h1 className={styles.title}>
          {t("page_not_found.title", "This page does not exist")}
        </h1>
        <p className={styles.body}>
          {t(
            "page_not_found.body",
            "The link may be broken or the page was moved."
          )}
        </p>
        <button type="button" className={styles.homeBtn} onClick={backToHome}>
          {t("page_not_found.back_home", "Back to Home")}
        </button>
        <button type="button" className={styles.goBack} onClick={goBack}>
          {t("page_not_found.go_back", "Go back")}
        </button>
      </div>
    </div>
  );
};

export default PageNotFound;
